// Action Constants

export enum ActionConstant {
	GET_LIST = 'FILE://TRADE_MANAGEMENT/GET_LIST',
	GET_DETAILS = 'FILE://TRADE_MANAGEMENT/GET_DETAILS',
	GET_STATUS = 'FILE://TRADE_MANAGEMENT/GET_STATUS',
	CLEAR_DETAILS = 'FILE://TRADE_MANAGEMENT/CLEAR_DETAILS',
	CLEAR_STATUS = 'FILE://TRADE_MANAGEMENT/CLEAR_STATUS',
}

// State Types
export interface List {
	count: number;
	rows: [];
}

export interface Details {
	id: number;
	name: string;
	isDefault: boolean;
	hasAIPrompts: boolean;
	defaultPackageName: string;
	materialStatusInstructions: string;
	materialScheduleInstructions: string;
}

export interface InitialState {
	initialList: boolean;
	fetching: boolean;
	detailsFetching: boolean;
	list: [];
	total: number;
	details: Details;
	statusCode: number;
	noOfResults: number;
	totalResults: number;
}

// Action Types

export interface GetListType {
	type: ActionConstant.GET_LIST;
	data: List;
}

export interface GetDetailsType {
	type: ActionConstant.GET_DETAILS;
	data: Details;
}

export interface GetStatusType {
	type: ActionConstant.GET_STATUS;
	status: number;
}
export interface ClearDetailsType {
	type: ActionConstant.CLEAR_DETAILS;
}

export interface ClearStatusType {
	type: ActionConstant.CLEAR_STATUS;
}

export type ActionType =
	| GetListType
	| GetDetailsType
	| GetStatusType
	| ClearDetailsType
	| ClearStatusType;
